import classNames from 'classnames/bind';
import React from 'react';

import styles from './TopStatusValue.module.scss';

const cx = classNames.bind(styles);

const TopStatusValue = ({ Icon, value, unit, style }) => {
  return (
    <div className={cx('container')} style={style}>
      <Icon size={16} color="white" />
      <div className={cx('value')}>
        {value ?? '-'}
        {unit && <span className={cx('unit')}>{unit}</span>}
      </div>
    </div>
  );
};

export default TopStatusValue;
